export const IMAGE_STATE_MOCKUP = "mockup" as const;
export const IMAGE_STATE_DECOMPOSED = "decomposed" as const;
export const IMAGE_STATE_DECOMP_SKIPPED = "decomp_skipped" as const;
export const IMAGE_STATE_DECOMP_FAILED = "decomp_failed" as const;

export type ImageState =
  | typeof IMAGE_STATE_MOCKUP
  | typeof IMAGE_STATE_DECOMPOSED
  | typeof IMAGE_STATE_DECOMP_SKIPPED
  | typeof IMAGE_STATE_DECOMP_FAILED;

export function isDecomposing(imageState: string | null | undefined): boolean {
  return imageState === IMAGE_STATE_MOCKUP;
}

export function isDecompFailed(imageState: string | null | undefined): boolean {
  return imageState === IMAGE_STATE_DECOMP_FAILED;
}
